export enum SystemMessageType {
  NONE = 0,
  SESSION_PURGE,
  TRADING_GRP_MEMBERSHIP_CHANGE,
  USER_PROFILE_CHANGE,
  BROADCAST_MESSAGE,
}
